import React, { useEffect } from "react";
import styles from "./TermsModal.module.scss";
import { useTranslation } from "react-i18next";

interface TermsModalProps {
  title: string;
  content: string;
  onClose: () => void;
}

const TermsModal: React.FC<TermsModalProps> = ({ title, content, onClose }) => {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const savedLanguage = localStorage.getItem("selectedLanguage") || "en";

    if (i18n.language !== savedLanguage) {
      i18n.changeLanguage(savedLanguage);
    }
  }, [i18n]);

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <h2 className={styles.title}>{title}</h2>
        <div className={styles.content}>
          <p>{content}</p>
        </div>
        <button className={styles.closeButton} onClick={onClose}>
          {t("terms.confirm")}
        </button>
      </div>
    </div>
  );
};

export default TermsModal;
